<svg:g [attr.class]="xAxisClassName" [attr.transform]="transform">
  @if (xScale) {
    <svg:g
      qmg-charts-x-axis-ticks
      [trimTicks]="trimTicks"
      [rotateTicks]="rotateTicks"
      [maxTickLength]="maxTickLength"
      [tickFormatting]="tickFormatting"
      [tickArguments]="tickArguments"
      [tickStroke]="tickStroke"
      [scale]="xScale"
      [orient]="xOrient"
      [showGridLines]="showGridLines"
      [gridLineHeight]="dims.height"
      [width]="dims.width"
      [tickValues]="ticks"
      [referenceLines]="referenceLines"
      [referenceLinesOutlet]="referenceLinesOutlet"
      [showRefLines]="showRefLines"
      [showRefLabels]="showRefLabels"
      (dimensionsChanged)="emitTicksHeight($event)"
      />
  }
  @if (showLabel) {
    <svg:g
      ngx-charts-axis-label
      [label]="labelText"
      [offset]="labelOffset"
      [orient]="Orientation.Bottom"
      [height]="dims.height"
      [width]="dims.width"
      ></svg:g>
    }
    </svg:g>
